import { render, staticRenderFns } from "./Suitability.vue?vue&type=template&id=60c56c5e"
import script from "./Suitability.vue?vue&type=script&lang=js"
export * from "./Suitability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports